import { Condition, Iteration } from 'Component/others';
import { Flex } from '@chakra-ui/react';
import { TextRegular } from 'UiKit/typography';

import styles from './styles.module.css';

const ColumnStock = ({ value }) => {
  return (
    <Flex
      flexDirection={'column'}
      width={'100%'}
      className={`${styles['column-stock__container']} ${value.length > 2 && styles['column-stock__container--margin']}`}
    >
      <Condition statement={value.length > 0} fallback={<TextRegular className={styles['column-stock__stock--text']}>-</TextRegular>}>
        <Iteration
          items={value.filter((_, index) => index < 2)}
          render={(item) => {
            return <TextRegular className={styles['column-stock__stock--text']}>{item?.availableStock}</TextRegular>;
          }}
        />
      </Condition>
    </Flex>
  );
};

export default ColumnStock;
